import React  from "react";
import { motion } from "framer-motion";
import Container from "../Container/Index";
import Category from "./Categorycard";
import "./Index.css";
import Title from "../Title/Index";
import Client from '../Client/Index';
import Error from '../../Error';
import Swiperslider from "../Swiperslider/Index";

const ProListing = ({ Data, clientData, servicePage, listingClass }) => {


  if (!Data || !Data.category || Data.category.length === 0) {
    return <Error />;
  }

  return (
    <Container _parentClass="position-relative serviceSection" containerClass={'float-end'}>
      {servicePage ? (
        <div className="row">
          <Title
            firstHeading={Data.heading}
            secondHeading={Data.title}
            subTitle={Data.descp}
          />
          <div className={`col-12 float-start ${listingClass}`}>
            <div className="col-lg-9 col-sm-10 col-12 m-auto sliderArrowRightBottom">
              <div className="row">
                {Data.category.map((product, index) => (
                  <motion.div
                    className="slides col-12 float-start p-0"
                    key={product.id || index}
                    whileHover={{ scale: 1.01 }}
                  >
                    <Category Data={product} />
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-12 float-start productStn p-100">
          <div className="col-lg-11 col-12 m-auto sliderArrowRightBottom bottomPosition">
            <div className="row">
              <Title
                firstHeading={Data.heading}
                secondHeading={Data.title}
                subTitle={Data.descp}
                _spanClass="text-white"
              />
           <Swiperslider slidesPerView={1.2} smallsliderperview={1.5} spaceBetween={25} navigation={true} timeDelay={'6000'} tabspaceBetween={15} loop={false}>
              {Data.category.map((product, index) => (                   
                   <Category Data={product} key={index}/>
                  ))}
                  </Swiperslider>
            </div>  
          </div>
        </div>
      )}

      {clientData && <Client Data={clientData} bgImage={'client_Bg_Image'} />}
    </Container>
  );
};

export default ProListing;
